import filter from './filter'

export default function remove(indexedNodes, nodes) {
  return filter(indexedNodes, (n) => nodes.map((n2) => n2.get('id')).indexOf(n.get('id')) < 0)
}
